import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["card"];
  static values = {
    type: String,
    selected: String
  };

  select(event) {
    this.cardTargets.forEach(card => card.classList.remove('selected'));
    event.currentTarget.classList.add('selected');
    this.selectedValue = event.currentTarget.dataset.value;
    this.dispatchUpdate();
  }

  dispatchUpdate() {
    this.dispatch('update', {
      detail: {
        type: this.typeValue,
        value: this.selectedValue
      }
    });
  }
}
